export const FlexibleHourVI ={
  "reasonFlexibleHour": {
    "title": "Lý do chế độ",
    "breadCrumb": "Quản lý lý do chế độ",
    "pageHeader": {
      "reasonFlexibleHour": "Quản lý lý do chế độ"
    }
  }
}
